"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MERCHANTS_READ_PRICE = exports.MCP_ALLOWED_MERCHANTS = exports.MCP_ALLOWED_FULFILLERS = exports.FULFILLERS_READ_PRICE = void 0;
var MCP_ALLOWED_MERCHANTS = 'mcp_allowed_merchants';
exports.MCP_ALLOWED_MERCHANTS = MCP_ALLOWED_MERCHANTS;
var MCP_ALLOWED_FULFILLERS = 'mcp_allowed_fulfillers';
exports.MCP_ALLOWED_FULFILLERS = MCP_ALLOWED_FULFILLERS;
var MERCHANTS_READ_PRICE = 'merchants_read_price';
exports.MERCHANTS_READ_PRICE = MERCHANTS_READ_PRICE;
var FULFILLERS_READ_PRICE = 'fulfillers_read_price';
exports.FULFILLERS_READ_PRICE = FULFILLERS_READ_PRICE;